import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../redux";
import { AgentEnvironment, agentEnvironmentActions } from "../../redux/reducers/agentEnvironmentSlice";
import { Button, Dialog, InputField, View } from "../base";
import { Icon } from "../base/Icon";

type CloneAgentEnvironmentDialogProps = {
  agentId: string;
  sourceEnvironment: AgentEnvironment | null;
  isOpen?: boolean;
  onClose?: () => void;
};

export const CloneAgentEnvironmentDialog = ({ agentId, sourceEnvironment, isOpen = false, onClose = () => {} }: CloneAgentEnvironmentDialogProps) => {
  const dispatch = useAppDispatch();
  const [name, setName] = useState("");
  const isLoading = useAppSelector((state) => state.agentEnvironment.isLoading);

  useEffect(() => {
    if (sourceEnvironment && isOpen) {
      setName(`${sourceEnvironment.name} (Copy)`);
    }
  }, [sourceEnvironment, isOpen]);

  const onClickClone = async () => {
    if (!sourceEnvironment) return;

    await dispatch(
      agentEnvironmentActions.clone({
        agentId,
        id: sourceEnvironment.id,
        name,
      }),
    );

    onClose();
    setName("");
    dispatch(agentEnvironmentActions.get({ agentId } as any) as any);
  };

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title="Clone Environment"
      className="w-full max-w-2xl max-h-[90vh] overflow-y-auto"
    >
      <View className="space-y-4 p-4">
        <InputField
          label="Name"
          value={name}
          onChange={(value) => setName(value)}
          placeholder="Enter environment name"
        />
        <View className="flex justify-end gap-2">
          <Button
            variant="neutral"
            size="sm"
            outline
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            variant="success"
            size="sm"
            outline
            onClick={onClickClone}
            disabled={isLoading || !name}
          >
            <Icon
              name="copy"
              size={14}
            />
            {isLoading ? "Cloning..." : "Clone Environment"}
          </Button>
        </View>
      </View>
    </Dialog>
  );
};
